module.exports = __webpack_public_path__ + "img/wbot.a79ea7ea.svg";